import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG
import { SkeletonModule } from 'primeng/skeleton';
import { TabsModule } from 'primeng/tabs';

// Local
import { ProcessModuleFields } from '../../../api/process-field/process-field';
import { PrcocessFieldsPermComponent } from './perm/perm.component';
import { SectionCardComponent } from '../shared.component';

@Component({
  selector: 'app-processfields-render',
  standalone: true,
  imports: [
    CommonModule,
    SkeletonModule,
    TabsModule,
    PrcocessFieldsPermComponent,
    SectionCardComponent
  ],
  template: `
    <ng-container *ngIf="processModule; else loading">
      <ng-container [ngSwitch]="processModule">
        <app-processmodules-perm
          *ngSwitchCase="'PERM Process Module'"
          [data]="data!"
          (save)="onSave($event)"
          (cancel)="onCancel()"
        ></app-processmodules-perm>
        <div *ngSwitchDefault class="p-3">
          No renderer found for process module: {{processModule}}
        </div>
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <p-tabs value="0">
        <p-tablist>
          <p-tab value="0">
            <p-skeleton width="100px" height="22px"></p-skeleton>
          </p-tab>
          <p-tab value="1">
            <p-skeleton width="120px" height="22px"></p-skeleton>
          </p-tab>
          <p-tab value="2">
            <p-skeleton width="110px" height="22px"></p-skeleton>
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
            <app-section-card [contentPadding]="[14, 14]">
              <div class="grid">
                <div class="col-6" *ngFor="let i of [1,2,3,4]">
                  <div class="field mb-3">
                    <p-skeleton width="150px" height="21px" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height="35px"></p-skeleton>
                  </div>
                </div>
              </div>
            </app-section-card>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </ng-template>
  `,
  styleUrls: ['./process-fields.component.scss'],
})
export class PrcocessFieldsComponent {
  @Input() data?: ProcessModuleFields;
  @Output() save = new EventEmitter<ProcessModuleFields>();
  @Output() cancel? = new EventEmitter<void>();

  get processModule(): string | undefined {
    return this.data?.processModule;
  }

  onSave(data: ProcessModuleFields): void {
    this.save.emit(data);
  }

  onCancel(): void {
    this.cancel?.emit();
  }
}
